const fetchVideoJobStatusSelector = (
    state: sage.state.IRedux
): sage.status.Fetch => state.createAnimation.fetchVideoJobStatus;

export default fetchVideoJobStatusSelector;
